import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "16",
  viewBox: "0 0 18 16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("ellipse", {
      cx: "9.02211",
      cy: "7.97266",
      rx: "8.06556",
      ry: "7.93925",
      transform: "rotate(0.629221 9.02211 7.97266)",
      fill: "#FF950A",
      "fill-opacity": "0.17"
    }, null, -1),
    _createElementVNode("path", {
      d: "M11.0011 7.99994H13.0001C13.9749 7.99994 14.4623 7.99994 14.7613 7.57996C15.0603 7.15997 14.9306 6.78536 14.6713 6.03615C14.0709 4.30217 12.6978 2.92902 10.9638 2.32868C10.2146 2.06929 9.83997 1.9396 9.41998 2.23863C9 2.53767 9 3.02509 9 3.99994V5.99994C9 6.94275 9 7.41415 9.29289 7.70705C9.58579 7.99994 10.0576 7.99994 11.0011 7.99994Z",
      fill: "#F76902",
      "fill-opacity": "0.92"
    }, null, -1)
  ])))
}
export default { render: render }